import { useEffect, useState } from 'react';

const moveItem = (items, idKey, draggedId, targetId) => {
  const dragged = items.find((item) => item[idKey] === draggedId);
  const rest = items.filter((item) => item[idKey] !== draggedId);
  const targetIndex = items.findIndex((item) => item[idKey] === targetId);
  return [...rest.slice(0, targetIndex), dragged, ...rest.slice(targetIndex)];
};

export const useDragOrder = (items, idKey, onReorder) => {
  const [order, setOrder] = useState(items);
  const [draggedId, setDraggedId] = useState(null);

  useEffect(() => setOrder(items), [items]);

  const dragHandlers = (itemId) => ({
    onDragStart: (event) => {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/plain', String(itemId));
      setDraggedId(itemId);
    },
    onDragOver: (event) => {
      event.preventDefault();
      if (draggedId && draggedId !== itemId) {
        setOrder((current) => moveItem(current, idKey, draggedId, itemId));
      }
    },
    onDrop: (event) => event.preventDefault(),
    onDragEnd: () => {
      setDraggedId(null);
      const ids = order.map((item) => item[idKey]);
      if (ids.join() !== items.map((item) => item[idKey]).join()) {
        onReorder(ids).catch(() => setOrder(items));
      }
    },
  });

  return { order, draggedId, dragHandlers };
};
